export default __webpack_public_path__ + "static/media/cc-2.54666f37.png";